import { CaseHearing, HearingType } from '@scts/models';
import { FormItem } from '@scts-ui/component-library';
import { AddressLineFormatter, longDateFormatter } from '@scts/utilities';

interface HearingProps {
  hearing: CaseHearing;
}

export const HearingComponent = (hearingProps: HearingProps) => {
  const location =
    hearingProps.hearing.address.addressLine1 +
    AddressLineFormatter(hearingProps.hearing.address.townCity) +
    AddressLineFormatter(hearingProps.hearing.address.postalCode);

  const googleSrc =
    'https://maps.google.com/maps?q=' +
    encodeURIComponent(location) +
    '&t=&z=13&ie=UTF8&iwloc=&output=embed';

  return (
    <>
      <FormItem
        header="Hearing Type:"
        detail={hearingProps.hearing.type}
        minWidthHeader={'9.7rem'}
        minWidthDetail={'9.7rem'}
      />

      {!hearingProps.hearing.isAdjourned && (
        <FormItem
          header="Hearing Date:"
          detail={longDateFormatter(new Date(hearingProps.hearing.date))}
          minWidthHeader={'9.7rem'}
          minWidthDetail={'9.7rem'}
        />
      )}

      {hearingProps.hearing.isAdjourned && (
        <div className="text-danger">
          <FormItem
            header="Hearing Date:"
            detail={
              'Hearing adjourned: ' +
              (hearingProps.hearing.adjournmentReason
                ? hearingProps.hearing.adjournmentReason
                : 'No reason given')
            }
            minWidthHeader={'9.7rem'}
            minWidthDetail={'9.7rem'}
          />
        </div>
      )}

      {hearingProps.hearing.type === HearingType.InPerson && (
        <>
          <FormItem
            header="Hearing Building: "
            detail={hearingProps.hearing.address.building}
            minWidthHeader={'9.7rem'}
            minWidthDetail={'9.7rem'}
          />

          <FormItem
            header="Hearing Location:"
            detail={location}
            minWidthHeader={'9.7rem'}
            minWidthDetail={'9.7rem'}
          />

          <iframe
            src={googleSrc}
            width="100%"
            height="100%"
            title="Google Map"
          ></iframe>
        </>
      )}
    </>
  );
};

export default HearingComponent;
